import { ReadonlyVec3, vec2, vec3 } from "gl-matrix";

export const epsilon = 1e-3;

export const HOVER_CURSOR_PROGRESS_ID = "hover-cursor-progress";
export const HOVER_CURSOR_PROGRESS_COLOR = "#42A5F5";

export function calculateSlope(start: ReadonlyVec3, end: ReadonlyVec3): string {
    const sub = vec3.sub(vec3.create(), start, end);
    const dir = vec3.normalize(vec3.create(), sub);

    const horizontal = Math.abs(dir[2]) < epsilon;
    const vertical = Math.abs(Math.abs(dir[2]) - 1) < epsilon;

    if (vertical) {
        return "Vertical";
    }
    if (horizontal) {
        return "Horizontal";
    }

    const planarVec = vec2.fromValues(sub[0], sub[1]);
    return `${(Math.abs(sub[2] / vec2.len(planarVec)) * 100).toFixed(2)} %`;
}

export function getSurfaceKey(setIdx: number, entityIdx: number) {
    return setIdx * 100 + entityIdx;
}
